import type { MarkerSdk } from '@marker.io/browser';

let markerSdk: MarkerSdk | null = null;
let markerShouldShow = true;

export function registerMarkerSdk(instance: MarkerSdk | null) {
    markerSdk = instance;
    if (markerSdk && !markerShouldShow) {
        markerSdk.hide();
    }
}

/** Hide or restore the Marker.io feedback tab. */
export function setMarkerSdkVisible(visible: boolean) {
    markerShouldShow = visible;
    if (!markerSdk) {
        return;
    }
    if (visible) {
        markerSdk.show();
    } else {
        markerSdk.hide();
    }
}

/** Open the Marker.io feedback capture flow (e.g. from a header button). */
export function openMarkerFeedback() {
    markerSdk?.capture('advanced');
}
